import React, { useState, useEffect } from 'react';

const rates = ['1%', '2%', '3%', '4%', '5%', '6%', '7%'];

const AnimatedHeader = ({ onAnimationEnd }) => {
  const [currentRate, setCurrentRate] = useState(-1);
  const [animationComplete, setAnimationComplete] = useState(false);

  useEffect(() => {
    // Increment currentRate every 200ms until we reach the end of the array
    const interval = setInterval(() => {
      setCurrentRate((prevRate) => {
        if (prevRate === rates.length - 1) {
          clearInterval(interval);
          setAnimationComplete(true);
          return prevRate; 
        }
        return prevRate + 1;
      });
    }, 200);

    return () => clearInterval(interval);
  }, []);

  // Once animationComplete is true, call onAnimationEnd after render
  useEffect(() => {
    if (animationComplete && onAnimationEnd) {
      // Defer calling onAnimationEnd so it doesn’t happen in the middle of render
      setTimeout(() => {
        onAnimationEnd();
      }, 0);
    }
  }, [animationComplete, onAnimationEnd]);

  return (
    <div className="centered-content">
      <h1 className="main-title">
        Best Bank Rates{' '}
        {animationComplete
          ? ''
          : currentRate >= 0
          ? rates[currentRate]
          : ''}
      </h1>
    </div>
  );
};

export default AnimatedHeader;
